<!-- Facebook Reels -->
<div class="mst">
  <div class="mst-screen fbr-screen">
    <app-meta-creative class="mst-creative" [src]="data.creative" [kind]="data.creativeKind" slot="story"></app-meta-creative>
    <div class="fbr-scrim"></div>

    <div class="fbr-copy">
      <div class="fbr-identity">
        <img class="fbr-avatar" [src]="avatar" alt="" />
        <span class="fbr-name">{{ pageName }}</span>
        <i class="bi bi-patch-check-fill fbr-badge"></i>
        <i class="bi bi-globe-americas fbr-badge"></i>
      </div>

      <div class="fbr-text">
        <span class="fbr-text-copy">{{ primaryText.text }}</span>
        <span *ngIf="primaryText.truncated">...more</span>
      </div>

      <a class="fbr-cta" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer" [style.background-color]="buttonTone">{{ cta }}</a>

      <span class="fbr-label">Oglas</span>
    </div>

    <i class="bi bi-reply fbr-share"></i>
    <i class="bi bi-three-dots fbr-dots"></i>
  </div>
</div>
